/**
 * View Offers / What's New delivery popovers on PDP buy-buttons.
 */
(function () {
  function closePanels(root) {
    root.querySelectorAll('[data-delivery-panel]').forEach(function (panel) {
      panel.hidden = true;
    });
    root.querySelectorAll('[data-delivery-open]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  function openPanel(root, name) {
    var panel = root.querySelector('[data-delivery-panel="' + name + '"]');
    if (!panel) return;
    closePanels(root);
    panel.hidden = false;
    var opener = root.querySelector('[data-delivery-open="' + name + '"]');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    var closeBtn = panel.querySelector('[data-close-delivery-panel]');
    if (closeBtn) closeBtn.focus();
  }

  function togglePanel(root, name) {
    var panel = root.querySelector('[data-delivery-panel="' + name + '"]');
    if (!panel) return;
    if (!panel.hidden) {
      closePanels(root);
      return;
    }
    openPanel(root, name);
  }

  function copyOfferCode(copyBtn) {
    var code = copyBtn.getAttribute('data-offer-code');
    if (!code) return;
    var panel = copyBtn.closest('[data-delivery-panel]');
    var status = panel ? panel.querySelector('[id^="OfferCopyStatus-"]') : null;
    var successMsg = copyBtn.getAttribute('data-copy-success') || '';

    function announce(msg) {
      if (status) {
        status.textContent = '';
        status.textContent = msg;
        window.setTimeout(function () {
          status.textContent = '';
        }, 2500);
      }
    }

    function done() {
      announce(successMsg);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(function () {
        fallbackCopy(code, done);
      });
    } else {
      fallbackCopy(code, done);
    }
  }

  function fallbackCopy(text, cb) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand('copy');
    } catch (err) {
      /* ignore */
    }
    document.body.removeChild(ta);
    if (cb) cb();
  }

  function initRoot(root) {
    root.addEventListener('click', function (e) {
      var copyTrigger = e.target.closest('[data-copy-offer-code]');
      if (copyTrigger && root.contains(copyTrigger)) {
        e.preventDefault();
        copyOfferCode(copyTrigger);
        return;
      }
      var openTrigger = e.target.closest('[data-delivery-open]');
      if (openTrigger && root.contains(openTrigger)) {
        e.preventDefault();
        var which = openTrigger.getAttribute('data-delivery-open');
        if (which) togglePanel(root, which);
        return;
      }
      var closeTrigger = e.target.closest('[data-close-delivery-panel]');
      if (closeTrigger && root.contains(closeTrigger)) {
        e.preventDefault();
        closePanels(root);
      }
    });
  }

  function onEscape(e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-delivery-popovers-root]').forEach(function (root) {
      var anyOpen = root.querySelector('[data-delivery-panel]:not([hidden])');
      if (anyOpen) {
        e.preventDefault();
        closePanels(root);
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-delivery-popovers-root]').forEach(initRoot);
    document.addEventListener('keydown', onEscape);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
